import React from "react";
import { Table } from "antd";
import get from "lodash/get";
import round from "lodash/round";


const TableSummary = ({ totals, hasData, filter }) => {
  switch (get(filter, "templateType")) {
    case 1:
      return (
        <>
          {hasData ? (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={15}>
                  <p className="font-semibold text-sm text-center">Total</p>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_shots", "0")}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_count", "0")}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_rejected_count")
                      ? `${get(totals, "total_rejected_count")}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_part_weight")
                      ? `${round(get(totals, "total_part_weight") / 1000, 2)}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={6} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_shot_weight")
                      ? `${round(get(totals, "total_shot_weight") / 1000, 2)}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "oee") ? `${get(totals, "oee")}` : "0"}
                  </span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          ) : null}
        </>
      );
    case 2:
      return (
        <>
          {hasData ? (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={10}>
                  <p className="font-semibold text-sm text-center">Total</p>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_length", "0")}
                  </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={3} className="text-center">
                  <span>
                    --
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_part_weight")
                      ? `${round(get(totals, "total_part_weight") / 1000, 2)}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={7} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "oee") ? `${get(totals, "oee")}` : "0"}
                  </span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          ) : null}
        </>
      );
    case 3:
      return (
        <>
          {hasData ? (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={12}>
                  <p className="font-semibold text-sm text-center">Total</p>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_count", "0")}
                  </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={3} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_rejected_count", "0")}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_part_weight")
                      ? `${round(get(totals, "total_part_weight") / 1000, 2)}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={7} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "oee") ? `${get(totals, "oee")}` : "0"}
                  </span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          ) : null}
        </>
      );
    case 4:
      return (
        <>
          {hasData ? (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={11}>
                  <p className="font-semibold text-sm text-center">Total</p>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_shots", "0") || 0}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} className="text-center">

                  <span className="font-semibold text-xs">
                    {get(totals, "total_count", "0") || 0}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_rejected_count")
                      ? `${get(totals, "total_rejected_count") || 0}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_raw_weight")
                      ? `${round(get(totals, "total_raw_weight") / 1000, 2)}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={6} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "total_finished_weight")
                      ? `${round(get(totals, "total_finished_weight") / 1000, 2)}`
                      : "0"}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} className="text-center">
                  <span className="font-semibold text-xs">
                    {get(totals, "oee") ? `${get(totals, "oee")}` : "0"}
                  </span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          ) : null}
        </>
      );
  }

};

export default TableSummary;
